export const menu = [
    {
        name: "dashboard",
        title: "داشبورد",
        controller: "dashboard",
        action: "dashboard",
        type: 1,
        children: [],
    },
    // {
    //     name: "widgetsHolder",
    //     title: "ویجت ها",
    //     controller: null,
    //     action: null,
    //     type: 3,
    //     children: [
    //         {
    //             name: "widgetsManagement",
    //             title: "ویجت های مدیریت",
    //             controller: null,
    //             action: null,
    //             type: 1,
    //         },
    //         {
    //             name: "widgetsWarehouse",
    //             title: "ویجت های انبار",
    //             controller: null,
    //             action: null,
    //             type: 1,
    //         },
    //         {
    //             name: "widgetsSales",
    //             title: "ویجت های فروش",
    //             controller: null,
    //             action: null,
    //             type: 1,
    //         },
    //         {
    //             name: "widgetsShoppingCart",
    //             title: "ویجت های سبد خرید",
    //             controller: null,
    //             action: null,
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "widgets",
    //     title: "ابزارها",
    //     controller: "widget",
    //     action: "widget",
    //     type: 3,
    //     children: [
    //         {
    //             name: "reports",
    //             title: "گزارش‌ها",
    //             controller: "widget",
    //             action: "reports",
    //             type: 1,
    //         },
    //         {
    //             name: "financialOrdersList",
    //             title: "لیست سفارش‌های مالی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "productsAccList",
    //             title: "لیست تجمیعی کالاها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "repetitiveNamesList",
    //             title: "لیست نام‌های تکراری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "monthlyProvinceTarget",
    //             title: "تارگت ماهانه طبق استان",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "usersListByNationalCode",
    //             title: "لیست کاربران طبق کد ملی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "usersListByHPH",
    //             title: "لیست کاربران طبق نام کاربری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "usersListByMobileNumber",
    //             title: "لیست کاربران طبق شماره موبایل",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "ordersPaymentDetails",
    //             title: "اطلاعات بانکی پرداخت‌کنندگان سفارش",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "ordersByPostalCode",
    //             title: "لیست سفارش‌ها بر اساس کدپستی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "getAccListByDate",
    //             title: "لیست تجمیعی بر اساس تاریخ",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "getAccListManualByDate",
    //             title: "لیست تجمیعی سفارش‌های اپراتوری بر اساس تاریخ",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "getOrderInfo",
    //             title: "لیست سفارش طبق کد سفارش",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "warehouseLabelByOrderID",
    //             title: "برچسب انبار بر اساس کد سفارش",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "warehouseLabelsFile",
    //             title: "دریافت برچسب به صورت گروهی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "warehouseInvoicesFile",
    //             title: "دریافت فاکتور به صورت گروهی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "cashReturnedOrders",
    //             title: "لیست سفارش‌های عودتی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "productsSort",
    //             title: "مرتب سازی محصولات",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "ticketListByTitle",
    //             title: "لیست تیکت طبق عنوان",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "ticketListByCRM",
    //             title: "لیست تیکت طبق کارشناس",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "orderProductsCountList",
    //             title: "تعداد اقلام کالاهای سفارش ها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "byBackOrderCalucate",
    //             title: "محاسبه مبلغ جریمه",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "sepidarExportExcel",
    //             title: "خروجی اکسل سپیدار",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "listOperations",
    //             title: "عملیات گروهی",
    //             controller: "widget",
    //             action: "list-operations",
    //             type: 1,
    //         },
    //         {
    //             name: "discountProductsList",
    //             title: "ایجاد تخفیف گروهی محصولات",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "sendFileOfTrackingPalette",
    //             title: "ثبت پیگیری مبادلات",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "commercialRequestExcelList",
    //             title: "ثبت درخواست حواله بازرگانی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "contentSetProductsKeyWords",
    //             title: "ثبت گروهی کلمات کلیدی محصولات",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "importCategoriesColor",
    //             title: "درج رنگ گروه های کالا",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "importProductsSort",
    //             title: "به روز رسانی ترتیب نمایش کالا ها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "importBrandsSort",
    //             title: "به روز رسانی ترتیب نمایش برند ها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "resetProductsSort",
    //             title: "ریست کردن ترتیب نمایش کالاها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "accountNumbersEdit",
    //             title: "ویرایش شماره‌های حساب",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "changeOrdersStatus",
    //             title: "تغییر وضعیت سفارش",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "barcodeEdit",
    //             title: "ویرایش بارکد",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "sendBulkTickets",
    //             title: "فرستادن تیکت گروهی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "updateCommissionPaidForOrders",
    //             title: "تغییر وضعیت پرداخت سفارش‌های عودتی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "orderInvoicesFinancial",
    //             title: "لیست فاکتورهای سفارش ها برای بخش مالی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //     ],
    // },
    {
        name: "managerialReports",
        title: "گزارش‌های مدیریتی",
        controller: "management-report",
        action: "management-report",
        type: 3,
        children: [
            {
                name: "warehouseExitReport",
                title: "خروج از انبار",
                controller: "management-report",
                action: "warehouse",
                type: 1,
            },
            // {
            //     name: "warehouseInvoicesExitReport",
            //     title: "فاکتورها",
            //     controller: "management-report",
            //     action: "invoice",
            //     type: 1,
            // },
            // {
            //     name: "totalProductChargeReport",
            //     title: "شارژ کالا",
            //     controller: "management-report",
            //     action: "charge",
            //     type: 1,
            // },
        ],
    },
    // {
    //     name: "warehouseReports",
    //     title: "گزارش‌های انبار",
    //     controller: "warehouse-report",
    //     action: "warehouse-report",
    //     type: 3,
    //     children: [
    //         {
    //             name: "warehouseExitReportsW",
    //             title: "خروج از انبار",
    //             controller: "warehouse-report",
    //             action: "warehouse",
    //             type: 1,
    //         },
    //         {
    //             name: "warehouseInvoicesExitReportW",
    //             title: "فاکتورها",
    //             controller: "warehouse-report",
    //             action: "invoice",
    //             type: 1,
    //         },
    //         {
    //             name: "totalProductChargeReportW",
    //             title: "شارژ کالا",
    //             controller: "warehouse-report",
    //             action: "charge",
    //             type: 1,
    //         },
    //     ],
    // },
    {
        name: "orders",
        title: "سفارش‌ها",
        controller: "order",
        action: "order",
        type: 3,
        children: [
            {
                name: "ordersList",
                title: "لیست سفارش‌ها",
                controller: "order",
                action: "list",
                type: 1,
            },
            // {
            //     name: "editOrdersPermission",
            //     title: "ویرایش سفارش‌ها",
            //     controller: "order",
            //     action: "edit",
            //     type: 2,
            // },
            // {
            //     name: "editOrderStatus",
            //     title: "ویرایش وضعیت سفارش",
            //     controller: "order",
            //     action: "changeStatus",
            //     type: 2,
            // },
            // {
            //     name: "exportOrderCommercesFile",
            //     title: "مجوز دریافت فایل اکسل حواله های فروش رفته",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "createManualOrder",
            //     title: "ساخت سفارش اپراتوری",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "exportProductCommercesFile",
            //     title: "مجوز دریافت فایل اکسل محصولات فروخته شده",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "orderDetail",
            //     title: "جزییات سفارش",
            //     controller: "order",
            //     action: "detail",
            //     type: 2,
            // },
            // {
            //     name: "warehouseExitLogs",
            //     title: "تاریخچه‌‌ی خروج",
            //     controller: "order",
            //     action: "exit",
            //     type: 1,
            // },
            // {
            //     name: "warehouseExitPrintLabelPermission",
            //     title: "پرینت برچسب",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "warehouseExitRevertPermission",
            //     title: "بازگشت خروج از انبار",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "warehouseExitPrintFactorPermission",
            //     title: "پرینت فاکتور",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "warehouseExitPrintAccumulativePermission",
            //     title: "پرینت تجمیعی",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "provinceOrdersList",
            //     title: "سفارش‌های بارگیری‌نشده",
            //     controller: "order",
            //     action: "deposit",
            //     type: 1,
            // },
        ],
    },
    // {
    //     name: "manualOrders",
    //     title: "سفارش‌های اپراتوری",
    //     controller: "manual-order",
    //     action: "manual-order",
    //     type: 3,
    //     children: [
    //         {
    //             name: "manualOrdersList",
    //             title: "لیست سفارش‌ها",
    //             controller: "manual-order",
    //             action: "list",
    //             type: 1,
    //         },
    //         {
    //             name: "deleteOrderManual",
    //             title: "حذف سفارشات اپراتوری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "warehouseExitLogsManual",
    //             title: "تاریخچه‌‌ی خروج",
    //             controller: "manual-order",
    //             action: "exit",
    //             type: 1,
    //         },
    //         {
    //             name: "warehouseExitManualPrintAccumulativePermission",
    //             title: "پرینت تجمیعی اپراتوری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "warehouseExitManualPrintFactorPermission",
    //             title: "پرینت فاکتور اپراتوری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "warehouseExitManualPrintLabelPermission",
    //             title: "پرینت برچسب اپراتوری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "warehouseExitManualRevertPermission",
    //             title: "بازگشت خروج سفارشات اپراتوری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "manualOrderAwaitingApproval",
    //             title: "سفارش‌های در انتظار تایید",
    //             controller: "manual-order",
    //             action: "awaiting",
    //             type: 1,
    //         },
    //         {
    //             name: "provinceOrdersListManual",
    //             title: "سفارشات بارگیری‌نشده",
    //             controller: "manual-order",
    //             action: "deposit",
    //             type: 1,
    //         },
    //     ],
    // },
    {
        name: "barcodeReader",
        title: "بارکدخوان",
        controller: "packing",
        action: "packing",
        type: 3,
        children: [
            {
                name: "barcodeReaderReports",
                title: "رتبه بندی کارکنان",
                controller: "packing",
                action: "ranking",
                type: 1,
            },
            // {
            //     name: "barcodeReportOperationPermission",
            //     title: "مجوز نمایش گزارش ها",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "barcodeOrders",
            //     title: "سفارش ها",
            //     controller: "packing",
            //     action: "orders",
            //     type: 1,
            // },
            // {
            //     name: "barcodeOrderRegister",
            //     title: "ثبت سفارش",
            //     controller: "packing",
            //     action: "register",
            //     type: 1,
            // },
        ],
    },
    // {
    //     name: "palettes",
    //     title: "مبادلات انبار مرکزی",
    //     controller: "central-exchange",
    //     action: "central-exchange",
    //     type: 3,
    //     children: [
    //         {
    //             name: "paletteRegister",
    //             title: "خروج مبادلات",
    //             controller: "central-exchange",
    //             action: "exit",
    //             type: 1,
    //         },
    //         {
    //             name: "deleteBarcodePermission",
    //             title: "مجوز حذف بارکد",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "paletteList",
    //             title: "لیست مبادلات",
    //             controller: "central-exchange",
    //             action: "list",
    //             type: 1,
    //         },
    //         {
    //             name: "getPaletteListPermission",
    //             title: "مجوز خروجی لیست بارکد ها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "paletteBoxesList",
    //             title: "لیست جعبه های مبادلات",
    //             controller: "central-exchange",
    //             action: "box",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "sepidar",
    //     title: "سپیدار",
    //     controller: "sepidar",
    //     action: "sepidar",
    //     type: 3,
    //     children: [
    //         {
    //             name: "sepidarInvoices",
    //             title: "فاکتورها",
    //             controller: "sepidar",
    //             action: "invoices",
    //             type: 1,
    //         },
    //         {
    //             name: "sepidarSetInvoices",
    //             title: "ثبت فاکتور های سپیدار",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //     ],
    // },
    {
        name: "tickets",
        title: "تیکت‌ها",
        controller: "ticket",
        action: "ticket",
        type: 3,
        children: [
            {
                name: "ticketsList",
                title: "تیکت‌ها",
                controller: "ticket",
                action: "list",
                type: 1,
            },
            // {
            //     name: "ticketsHistoryLogs",
            //     title: "مشاهده‌ی تاریخچه‌ی ویرایش وضعیت",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "createOrderFormTicket",
            //     title: "ایجاد سفارش از تیکت",
            //     controller: null,
            //     action: null,
            //     type: 2,
            // },
            // {
            //     name: "ticketsCategories",
            //     title: "دسته‌بندی",
            //     controller: "ticket",
            //     action: "category",
            //     type: 1,
            // },
            // {
            //     name: "ticketsRoles",
            //     title: "نقش‌ها",
            //     controller: "ticket",
            //     action: "roles",
            //     type: 1,
            // },
            // {
            //     name: "closeTickets",
            //     title: "بستن تیکت‌ها",
            //     controller: "ticket",
            //     action: "close",
            //     type: 1,
            // },
            // {
            //     name: "ticketPoint",
            //     title: "امتیاز دهی",
            //     controller: "ticket",
            //     action: "point",
            //     type: 1,
            // },
            {
                name: "singleTicket",
                title: "تیکت تکی",
                controller: "ticket",
                action: "single",
                type: 1,
            },
            // {
            //     name: "templateResponses",
            //     title: "پاسخ های نمونه",
            //     controller: "ticket",
            //     action: "template",
            //     type: 1,
            // },
        ],
    },
    // {
    //     name: "postSettings",
    //     title: "تنظیمات پست",
    //     controller: "post",
    //     action: "post",
    //     type: 3,
    //     children: [
    //         {
    //             name: "mahexSettings",
    //             title: "شرکت های پستی",
    //             controller: "post",
    //             action: "company",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "productCommentPage",
    //     title: "نظرات",
    //     controller: "comment",
    //     action: "comment",
    //     type: 3,
    //     children: [
    //         {
    //             name: "productCommentList",
    //             title: "لیست نظرات",
    //             controller: "comment",
    //             action: "list",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "productsSection",
    //     title: "محصولات",
    //     controller: "product",
    //     action: "product",
    //     type: 3,
    //     children: [
    //         {
    //             name: "brands",
    //             title: "برندها",
    //             controller: "product",
    //             action: "brand",
    //             type: 1,
    //         },
    //         {
    //             name: "categories",
    //             title: "گروه‌ها",
    //             controller: "product",
    //             action: "group",
    //             type: 1,
    //         },
    //         {
    //             name: "excelExportCategories",
    //             title: "مجوز خروجی اکسل لیست گروه ها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "productColor",
    //             title: "رنگ ها",
    //             controller: "product",
    //             action: "color",
    //             type: 1,
    //         },
    //         {
    //             name: "productGroupFile",
    //             title: "گروه بندی فایل ها",
    //             controller: null,
    //             action: null,
    //             type: 1,
    //         },
    //         {
    //             name: "productInsertFile",
    //             title: "درج فایل",
    //             controller: "product",
    //             action: "file",
    //             type: 1,
    //         },
    //         {
    //             name: "products",
    //             title: "محصولات",
    //             controller: "product",
    //             action: "list",
    //             type: 1,
    //         },
    //         {
    //             name: "policyProductOverview",
    //             title: "مجوز نمای کلی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductPrice",
    //             title: "مجوز قیمت",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductDescription",
    //             title: "مجوز توضیحات",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductSearch",
    //             title: "مجوز موتور جستجو",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductAlbum",
    //             title: "مجوز آلبوم",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductWarehouseService",
    //             title: "مجوز انبار خدمات",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyBasketLimit",
    //             title: "مجوز سقف سبد خرید",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductBarcode",
    //             title: "مجوز بارکد",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductOther",
    //             title: "مجوز سایر",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductAttribute",
    //             title: "مجوز ویژگی ها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "policyProductColor",
    //             title: "مجوز رنگ ها",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "deleteProductPermission",
    //             title: "حذف کالا",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "changeProductCountPermission",
    //             title: "ویرایش موجودی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "editProductPermission",
    //             title: "ویرایش کالا",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "changeProductCountPermission",
    //             title: "ویرایش موجودی کالا",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "createProductPermission",
    //             title: "ایجاد کالا",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "productAttribute",
    //             title: "ویژگی ها",
    //             controller: "product",
    //             action: "attribute",
    //             type: 1,
    //         },
    //         {
    //             name: "productModifyLogs",
    //             title: "تاریخچه تغییرات محصولات",
    //             controller: "product",
    //             action: "modify-log",
    //             type: 1,
    //         },
    //         {
    //             name: "productsLogs",
    //             title: "تاریخچه‌ی محصولات",
    //             controller: "product",
    //             action: "log",
    //             type: 1,
    //         },
    //         {
    //             name: "excelExportProductLog",
    //             title: "مجوز خروجی اکسل",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //     ],
    // },
    // {
    //     name: "marketers",
    //     title: "مشتریان",
    //     controller: "customer",
    //     action: "customer",
    //     type: 3,
    //     children: [
    //         {
    //             name: "marketersList",
    //             title: "لیست مشتریان",
    //             controller: "customer",
    //             action: "list",
    //             type: 1,
    //         },
    //         {
    //             name: "excelExportCustomer",
    //             title: "مجوز خروجی اکسل کاربران",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "customerShowWalletPermission",
    //             title: "مجوز نمایش کیف پول",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "customerChargeWalletPermission",
    //             title: "مجوز شارژ کیف پول",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "editMarketer",
    //             title: "ویرایش تطلاعات شخصی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "marketerOverviewPermission",
    //             title: "مجوز نمایش مشخصات شخصی مشتری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "editMarketerHPH",
    //             title: "ویرایش اطلاعات مشتری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "changeMarketerPassword",
    //             title: "تغییر رمز ورود",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "marketerInfoPermission",
    //             title: "مجوز نمایش مشخصات مشتری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "addressInfoPermission",
    //             title: "مجوز نمایش اطلاعات آدرس مشتری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "contactInfoPermission",
    //             title: "مجوز نمایش اطلاعات تماس مشتری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "financialInfoPermission",
    //             title: "مجوز نمایش اطلاعات بانکیs",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "customerCodeReagentPermission",
    //             title: "مجوز نمایش کد معرف",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "usersWalletReportPage",
    //             title: "گزارش کیف پول",
    //             controller: "customer",
    //             action: "wallet",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "FAQsection",
    //     title: "سوالات متداول",
    //     controller: "FAQ",
    //     action: "FAQ",
    //     type: 3,
    //     children: [
    //         {
    //             name: "FAQ",
    //             title: "سوالات متداول",
    //             controller: "FAQ",
    //             action: "list",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "commercial",
    //     title: "بازرگانی",
    //     controller: "commercial",
    //     action: "commercial",
    //     type: 3,
    //     children: [
    //         {
    //             name: "supplier",
    //             title: "تامین کنندگان",
    //             controller: "commercial",
    //             action: "supplier",
    //             type: 1,
    //         },
    //         {
    //             name: "commercialRequest",
    //             title: "درخواست ها",
    //             controller: "commercial",
    //             action: "request",
    //             type: 1,
    //         },
    //         {
    //             name: "commercialDiscount",
    //             title: "تخفیف حواله",
    //             controller: "commercial",
    //             action: "discount",
    //             type: 1,
    //         },
    //         {
    //             name: "commercialManagementRequest",
    //             title: "درخواست های مدیر",
    //             controller: "commercial",
    //             action: "management-request",
    //             type: 1,
    //         },
    //         {
    //             name: "commercialManagementRequestPolicy",
    //             title: "مجوز تایید درخواست بازرگانی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "commercialManagementExcelPolicy",
    //             title: "مجوز فایل اکسل حواله های مدیریت",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "commercialPricing",
    //             title: "قیمت گذاری",
    //             controller: "commercial",
    //             action: "pricing",
    //             type: 1,
    //         },
    //         {
    //             name: "commercialPricingPermission",
    //             title: "مجوز قیمت گذاری",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "commercialFinancialRequest",
    //             title: "درخواست های مالی",
    //             controller: "commercial",
    //             action: "financial-request",
    //             type: 1,
    //         },
    //         {
    //             name: "commercialFinancialRequestPolicy",
    //             title: "مجوز درخواست های مالی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "commercialFinancialExcelPolicy",
    //             title: "مجوز اکسل درخواست های مالی",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "commercialWarehouseRequest",
    //             title: "درخواست های انبار",
    //             controller: "commercial",
    //             action: "warehouse-request",
    //             type: 1,
    //         },
    //         {
    //             name: "commercialWarehouseRequestPolicy",
    //             title: "مجوز درخواست های انبار",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "commercialWarehouseExcelPolicy",
    //             title: "مجوز فایل اکسل حواله های انبار",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //     ],
    // },
    // {
    //     name: "marketing",
    //     title: "مارکتینگ",
    //     controller: "marketing",
    //     action: "marketing",
    //     type: 3,
    //     children: [
    //         {
    //             name: "MarketingCodeReagent",
    //             title: "کد معرف",
    //             controller: "marketing",
    //             action: "reagent-code",
    //             type: 1,
    //         },
    //         {
    //             name: "discountPostOption",
    //             title: "مدیریت هزینه پستی",
    //             controller: "marketing",
    //             action: "post-discount",
    //             type: 1,
    //         },
    //         {
    //             name: "campaign",
    //             title: "کمپین",
    //             controller: "marketing",
    //             action: "campaign",
    //             type: 1,
    //         },
    //         {
    //             name: "discountOrderCart",
    //             title: "کد تخفیف",
    //             controller: "marketing",
    //             action: "discount",
    //             type: 1,
    //         },
    //         {
    //             name: "policyExportDiscountUsesReport",
    //             title: "مجوز دریافت فایل اکسل کدهای تخفیف استفاده شده",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "createNewDiscountOrderCartFile",
    //             title: "مجوز ایجاد گروهی کد تخفیف با اکسل",
    //             controller: null,
    //             action: null,
    //             type: 2,
    //         },
    //         {
    //             name: "discountOrderCartLeaderBoard",
    //             title: "کد تخفیف تابلو امتیاز",
    //             controller: "marketing",
    //             action: "leaderBoard-discount",
    //             type: 1,
    //         },
    //         {
    //             name: "leaderboard",
    //             title: "تابلو امتیازها",
    //             controller: "marketing",
    //             action: "leaderboard",
    //             type: 1,
    //         },
    //         {
    //             name: "leaderboardGame",
    //             title: "بازی ها",
    //             controller: "marketing",
    //             action: "games",
    //             type: 1,
    //         },
    //         {
    //             name: "leaderboardPrize",
    //             title: "جایزه ها",
    //             controller: "marketing",
    //             action: "prizes",
    //             type: 1,
    //         },
    //         {
    //             name: "leaderboardEvent",
    //             title: "رویداد ها",
    //             controller: "marketing",
    //             action: "events",
    //             type: 1,
    //         },
    //         {
    //             name: "gamePrize",
    //             title: "جوایز بازی ها",
    //             controller: "marketing",
    //             action: "gamePrize",
    //             type: 1,
    //         },
    //         {
    //             name: "discountPrize",
    //             title: "جوایز کد تخفیف",
    //             controller: "marketing",
    //             action: "discountPrize",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "contents",
    //     title: "محتوا",
    //     controller: "content",
    //     action: "content",
    //     type: 3,
    //     children: [
    //         {
    //             name: "contactUs",
    //             title: "تماس با ما",
    //             controller: "content",
    //             action: "contact-us",
    //             type: 1,
    //         },
    //         {
    //             name: "contentPosition",
    //             title: "موقعیت نمایش",
    //             controller: "content",
    //             action: "position",
    //             type: 1,
    //         },
    //         {
    //             name: "sliderContent",
    //             title: "اسلایدر",
    //             controller: "content",
    //             action: "slider",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "websiteBlog",
    //     title: "وبلاگ",
    //     controller: "blog",
    //     action: "blog",
    //     type: 3,
    //     children: [
    //         {
    //             name: "blogAuthor",
    //             title: "نویسنده",
    //             controller: "blog",
    //             action: "author",
    //             type: 1,
    //         },
    //         {
    //             name: "blogTag",
    //             title: "برچسب",
    //             controller: "blog",
    //             action: "tag",
    //             type: 1,
    //         },
    //         {
    //             name: "blogFAQ",
    //             title: "سوالات متداول",
    //             controller: "blog",
    //             action: "FAQ",
    //             type: 1,
    //         },
    //         {
    //             name: "blogComment",
    //             title: "نظرات",
    //             controller: "blog",
    //             action: "comment",
    //             type: 1,
    //         },
    //         {
    //             name: "blogContent",
    //             title: "محتوا",
    //             controller: "blog",
    //             action: "content",
    //             type: 1,
    //         },
    //         {
    //             name: "blogGroup",
    //             title: "گروه",
    //             controller: "blog",
    //             action: "group",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "questionnaire",
    //     title: "پرسشنامه",
    //     controller: "questionnaire",
    //     action: "questionnaire",
    //     type: 3,
    //     children: [
    //         {
    //             name: "questionnaireGroup",
    //             title: "گروه بندی",
    //             controller: "questionnaire",
    //             action: "questionnaireGroup",
    //             type: 1,
    //         },
    //         {
    //             name: "questionnaireQA",
    //             title: "سوال و جواب",
    //             controller: "questionnaire",
    //             action: "QA",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "roles",
    //     title: "نقش‌ها",
    //     controller: "role",
    //     action: "role",
    //     type: 3,
    //     children: [
    //         {
    //             name: "rolesSettings",
    //             title: "تنظیمات",
    //             controller: "role",
    //             action: "setting",
    //             type: 1,
    //         },
    //         {
    //             name: "userRoles",
    //             title: "کاربران",
    //             controller: "role",
    //             action: "user",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "landingPage",
    //     title: "لندینگ",
    //     controller: "landingPage",
    //     action: "landingPage",
    //     type: 3,
    //     children: [
    //         {
    //             name: "landingPageList",
    //             title: "لیست",
    //             controller: "landingPage",
    //             action: "list",
    //             type: 1,
    //         },
    //     ],
    // },
    // {
    //     name: "settings",
    //     title: "تنظیمات",
    //     controller: "setting",
    //     action: "setting",
    //     type: 3,
    //     children: [
    //         {
    //             name: "changePassword",
    //             title: "تغییر کلمه‌ی عبور",
    //             controller: "تالتاغل",
    //             action: "تالتال",
    //             type: 1,
    //         },
    //         {
    //             name: "personalSettings",
    //             title: "تنظیمات شخصی",
    //             controller: "setting",
    //             action: "personal",
    //             type: 1,
    //         },
    //         {
    //             name: "managePages",
    //             title: "مدیریت صفحه ها",
    //             controller: "setting",
    //             action: "manage-pages",
    //             type: 1,
    //         },
    //     ],
    // },
]
